import { ReportDetailState } from "./interface";
import { getAutosavePreference } from "~/helpers";

export const REPORT_DETAIL_INITIAL_STATE: ReportDetailState = {
  data: {
    sections: [],
    deletedSections: [],
    metadata: null,
    reportType: "",
    profileImage: null,
    selectedCombinedFilter: "combined_data",
    combinedReportSources: [],
    summaryData: null,
    summaryStatus: undefined,
    summaryErrorMessage: null,
    sectionsWithSummary: [],
  },
  ui: {
    sectionListRecords: [],
    relacoesSectionList: [],
    totalRecords: 0,
    reloadTrigger: 0,
    isActionLoading: false,
    activeSection: null,
    isScrollLoading: false,
    accordionToggle: null,
    pendingScrollTarget: null,
    openSections: [],
    openSectionsTrash: [],
    activeRelacaoTab: "semactic-analysis",
    highlightedEntityId: null,
    refetchReport: null,
    generatingSummaryReportIds: [],
  },
  autoSave: {
    timeoutId: null,
    isPending: false,
    hasPendingChanges: false,
    mutation: null,
    isEnabled: getAutosavePreference(), // Load from localStorage
  },
};
